/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './QuerySourceRendererStyles.scss';
const baseClass = 'qmb-ui-QuerySourceRenderer';
export function QuerySourceRenderer({ block }) {
    const qs = block;
    // Handle simple format: { query: "Source tables: buildings" }
    if (qs.query && !qs.source_type) {
        return (React.createElement(AIGeneralBlockCard, { sections: [
                {
                    label: 'Source',
                    content: (React.createElement("div", { className: baseClass },
                        React.createElement(Text, { variant: "body" }, qs.query)))
                }
            ] }));
    }
    return (React.createElement(AIGeneralBlockCard, { sections: [
            {
                label: `Source: ${qs.source_type}`,
                content: (React.createElement("div", { className: baseClass },
                    React.createElement(Text, { variant: "body" },
                        qs.row_count,
                        " rows in ",
                        qs.execution_time_ms,
                        "ms"),
                    qs.tables_used && qs.tables_used.length > 0 && (React.createElement(Text, { variant: "body", className: `${baseClass}__tables` },
                        "Tables: ",
                        qs.tables_used.join(', ')))))
            }
        ] }));
}
